import { IconButton, styled } from "@mui/material";
import { useLocales } from "../../hooks";
import { useParams } from "react-router-dom";
import { useGetListQuery } from "../../features/api/Api";
import { useState } from "react";
import { formatDate, isExists, params } from "../../utils";
import { GridColDef } from "@mui/x-data-grid";
import { List, MuiDatagrid } from "../../components";
import { defaultToolbar } from "../../components/views/datagrid/MuiDatagrid";
import ToolTip from "../../components/tooltip/ToolTip";

const EditButton = styled(IconButton)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  color: "#853EF8",
  "&:hover": {
    backgroundColor: "transparent",
    borderColor: "#0062cc",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});
const CustomerProductList = () => {
  const { translate } = useLocales();
  const tableName = "Aktif Hizmetler";
  const { customerId } = useParams();

  const [productParams, setProductParams] = useState({
    resource: `fixity/order/variant/get-active-variants-in-order-for-customerId`,
    params: {
      ...params,
      filter: { customerId: customerId },
    },
  });

  const { data: products, isLoading } = useGetListQuery<any>(productParams);

  const columns: GridColDef[] = [
    {
      // ürün tipi
      field: "productTypeName",
      headerName: translate("resources.customers.products.productTypes_name"),
      flex: 1,
      renderCell: (params) => {
        return (
          <ToolTip title={params.row.productTypeName}>
            <div>{params.row.productTypeName}</div>
          </ToolTip>
        );
      },
    },
    {
      // ürün varyantı
      field: "variantName",
      headerName: translate("resources.customers.products.variant_name"),
      flex: 1,
      renderCell: (params) => {
        return (
          <ToolTip title={params.row.variantName}>
            <div>{params.row.variantName}</div>
          </ToolTip>
        );
      },
    },
    {
      // ürün varyantı
      field: "campaignName",
      headerName: "Kampanya / Tarife",
      flex: 1,
      renderCell: (params) => {
        return (
          <ToolTip title={params.row.campaignName}>
            <div>{params.row.campaignName}</div>
          </ToolTip>
        );
      },
    },
    {
      // ürün varyantı
      field: "devreTarifNo",
      headerName: "Devre Numarası",
      flex: 1,
    },
    {
      // start date
      field: "serviceStartDate",
      headerName: translate("resources.customers.products.startDate"),
      flex: 1,
      renderCell: (params) => {
        return params.row.serviceStartDate
          ? formatDate(new Date(params.row.serviceStartDate))
          : "";
      },
    },

    {
      // ürün varyantı
      field: "proposalPrice",
      headerName: "Birim Fiyat", //birim fiyat
      flex: 1,
    },
    {
      // end date
      field: "currentStatus",
      headerName: translate("resources.customers.products.currenctStatus"),
      flex: 1,
      renderCell: (params) => {
        return params.row.isCommittedProduct
          ? `${params.row.usedDuration}/${params.row.duration}`
          : translate("resources.sales.proposal.not_commitment");
      },
    },
  ];

  return (
    <>
      <List loading={isLoading}>
        <MuiDatagrid
          loading={isLoading}
          rows={isExists(products?.data) ? products.data : []}
          columns={columns}
          rowCount={products?.totalItemCount}
          pageSize={productParams.params.pagination.size}
          pageNumber={productParams.params.pagination.pageNumber}
          setPagination={setProductParams}
          hideToolbars={{ ...defaultToolbar, create: false, filter: false }}
          autoHeight
        />
      </List>
    </>
  );
};

export default CustomerProductList;
